import * as React from 'react'

import { BankingValueObjectsOnboardingStatusEnum } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { BankAccount } from 'modules/expenses/lib/types'

import CardsNotification from './CardsNotification'
import DeadlineNotification from './DeadlineNotification'
import { FundsNotification } from './FundsNotification'
import { OnboardingNotification } from './OnboardingNotification'

interface Props {
  bankAccount?: BankAccount
  onboardingStatus: BankingValueObjectsOnboardingStatusEnum
  onboardingDeadline?: string
  bankAddress?: string
  locale: string
}

const DefaultNotification = observer(
  ({ bankAccount, onboardingStatus, onboardingDeadline, bankAddress, locale }: Props) => {
    const hasCreatedCards = !!bankAccount?.cardholders.some(
      (cardholder) => (cardholder.cardsConnection?.totalCount || 0) > 0
    )

    if (!bankAccount || onboardingStatus != 'completed') {
      if (onboardingDeadline) {
        return <DeadlineNotification onboardingDeadline={onboardingDeadline} />
      }
      return <OnboardingNotification onboardingStatus={onboardingStatus} />
    }

    if (bankAccount.availableBalanceCents < bankAccount.lowBalanceThresholdCents && bankAddress) {
      return (
        <FundsNotification bankAccount={bankAccount} bankAddress={bankAddress} locale={locale} />
      )
    }

    if (!hasCreatedCards) {
      return <CardsNotification />
    }

    return null
  }
)

export { DefaultNotification }
